export default __webpack_public_path__ + "static/media/3470.4098c7a2.png";